import { render, staticRenderFns } from "./nav.vue?vue&type=template&id=ca4030da&scoped=true"
import script from "./nav.vue?vue&type=script&lang=js"
export * from "./nav.vue?vue&type=script&lang=js"
import style0 from "./nav.vue?vue&type=style&index=0&id=ca4030da&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/.store/vue-loader@15.11.1/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ca4030da",
  null
  
)

export default component.exports